<template>
  <div class="hero-widget">
    <div
      v-for="(item, index) in heroPostsWidget.items"
      :key="index"
      class="item"
      :style="itemBackgroundStyle(item)">
      <div>
        <h1>
          <router-link :to="{ 
            name: 'post',
            params: { 
              year: getDateObject(item.post.date).year,
              month: getDateObject(item.post.date).month,
              day: getDateObject(item.post.date).day,
              post: item.post.slug
            }
          }">
            {{ item.title }}
          </router-link>
        </h1>
        <div v-html="parsedDescription(item.description)" class="item-description"/>
      </div>
      <CallToAction :id="item.callToAction.id" />
    </div>
  </div>    
</template>

<script>

import gql from 'graphql-tag'
import marked from 'marked'

import CallToAction from 'components/CallToAction.vue'

export default {
  name: 'HeroWidget',
  components: {
    CallToAction
  },
  data() {
    return {
      heroPostsWidget: {}
    }
  },
  props: [
    'id'
  ],
  apollo: {
    heroPostsWidget: {
      query: gql`query HeroWidget ($id: ItemId) {
        heroPostsWidget(filter: {id: {eq: $id}}) {
          title
          items {
            title
            description
            callToAction { id }
            post {
              title
              slug
              date
            }
            backgroundImage { url }
            backgroundPosition
          }
        }
      }`,
      variables() {
        return {
          id: this.id
        }
      }
    }
  },
  methods: {
    parsedDescription(description) {
      return marked(description, {
        sanitize: false
      });
    },
    getDateObject: (dateString) => (([year, month, day]) => ({ day, month, year }))(dateString.split('T')[0].split('-')),
    itemBackgroundStyle(item) {
      if (!item.backgroundImage) return {}
      return {
        'background-image': 'url(' + item.backgroundImage.url + ')',
        'background-position': item.backgroundPosition
      }
    }
  }
}
</script>

<style scoped lang="less">

</style>
